<template>
  <section class="container mt-3 mb-7" id="topBrands">
    <div class="section-title mb-6">
      <h2>{{ translations.topBrands }}</h2>
    </div>

    <VueSlickCarousel
      class="partners-carousel owl-carousel owl-theme text-center top-brands-carousel"
      v-bind="slickSettings"
      v-if="brands && brands.length > 0"
    >
      <router-link
        v-for="item in brands"
        :key="item.brandId"
        :to="{ name: 'Brand',
         params: { id: item.brandId, title: item.brandTitle.replace(/\s+/g, '-') } }"
         @click.native="trackConversionForBrand(item.brandId, item.brand.replace(/\s+/g, '-'))"
      >
        <img
          :src="`${baseUrl}${item.externalBrandImageUrl || item.brandOriginalImageUrl}`"
          :alt="item.brandTitle"
          class="brand-image"
        />
      </router-link>
    </VueSlickCarousel>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import './slick.css';

import config from '@/config';
import { translations } from '@/mixins';

export default {
  name: 'TopBrands',
  mixins: [translations],
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      slickSettings: {
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        speed: 750,
        autoplaySpeed: 5000,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            },
          },
          {
            breakpoint: 360,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            },
          },
        ],
      },
    };
  },
  computed: {
    brands() {
      return this.$store.getters.getTopBrands;
    },
    baseUrl() {
      return config.baseUrl;
    },
  },
  mounted() {
    this.$store.dispatch('getTopBrands');
  },
};
</script>
<style lang="scss" scoped>
.brand-image {
  width: auto;
  margin: 0 auto;
}
</style>

<style lang="scss">
.top-brands-carousel {
  .slick-arrow {
    background: transparent;
  }

  .slick-prev:before,
  .slick-next:before {
    background: transparent;
  }
}
</style>
